module.exports = __webpack_public_path__ + "img/Endijs-Karklins.e97b2d71.svg";